import { Injectable } from "@angular/core";
import { CommonState } from "@obg/ngx.common";
import { MessageSelector } from "@obg/ngx.core";
import { isEqual } from "lodash-es";
import { Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

import { RegistrationFeatureState } from "../state";

import { REGISTRATION_ACTION_TYPE } from "./registration.action";
import {
	RegistrationFormFlow,
	RegistrationPayload,
	RegistrationState,
	RegistrationStatusResponse,
} from "./registration.model";
import { RegistrationService } from "./registration.service";
import { RegistrationWithSPIDState } from "./spid/registration-with-spid.model";
@Injectable({
	providedIn: "root",
})
export class RegistrationSelector {
	constructor(
		private messageSelector: MessageSelector,
		private service: RegistrationService
	) {}

	getState() {
		return (state: RegistrationFeatureState): RegistrationState => state.registrationFeature.registration;
	}

	getToken() {
		return (state: RegistrationFeatureState): string | undefined => state.registrationFeature.registration.token;
	}

	getSPIDRegistrationState() {
		return (state: RegistrationFeatureState): RegistrationWithSPIDState | undefined =>
			state.registrationFeature.registrationWithSPID;
	}

	getLastStatus() {
		return (state: RegistrationFeatureState): RegistrationStatusResponse | undefined =>
			state.registrationFeature.registration.lastStatus;
	}

	getEmailVerificationToken() {
		return (state: RegistrationFeatureState): string | undefined =>
			state.registrationFeature.registration.emailVerificationToken;
	}

	getRegistrationDetails() {
		return (state: RegistrationFeatureState): RegistrationPayload | undefined =>
			state.registrationFeature.registration.registrationDetails;
	}

	getInitialStep() {
		return (state: RegistrationFeatureState & CommonState): number | undefined =>
			state.registrationFeature.registration.initialStep;
	}

	getRegistrationFlow() {
		return (state: RegistrationFeatureState & CommonState): RegistrationFormFlow | undefined =>
			state.registrationFeature.registration.flow;
	}

	isSuccessful() {
		return (state: RegistrationFeatureState): boolean | undefined =>
			state.registrationFeature.registration.isSuccessful;
	}

	isBusy() {
		return (state: RegistrationFeatureState): boolean => state.registrationFeature.registration.isBusy;
	}

	getErrors() {
		return (state: RegistrationFeatureState & CommonState): string[] | undefined =>
			this.service.getErrors(
				state.registrationFeature.registration.lastStatus,
				this.messageSelector.getFirst({ context: REGISTRATION_ACTION_TYPE.getRegistrationToken })(state)
			);
	}

	getErrors$() {
		return (state$: Observable<RegistrationFeatureState & CommonState>): Observable<string[]> =>
			state$.pipe(
				distinctUntilChanged(isEqual, (state) => [
					state.registrationFeature.registration.lastStatus,
					state.message,
				]),
				map(this.getErrors()),
				distinctUntilChanged(isEqual)
			);
	}
}
